<ng-container *transloco="let t">
  <div class="header-wrapper">
    <mzic-header [homeFocused]="false"></mzic-header>
  </div>
  
  <section class="desktop-unavailable-section">
    <div class="mouse-gradient"></div>
    
    <div class="particles">
      <span class="particle" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]"></span>
    </div>
    
    <div class="floating-tech-elements">
      <div 
        *ngFor="let element of floatingElements; let i = index"
        class="floating-tech floating-tech-{{i}}"
        [class.crossed-out]="element.crossed"
        [style.left.%]="element.x"
        [style.top.%]="element.y">
        {{ element.icon }}
        <span *ngIf="element.crossed" class="cross-line"></span>
      </div>
    </div>
    
    <div class="desktop-unavailable-container">
      <div class="desktop-unavailable-content" [@fadeInUp]>
        
        <div class="message-content" [@fadeInUp]>
          <h1 class="main-title">{{ t('lang.title') }}</h1>
          <p class="main-subtitle">{{ t('lang.subtitle') }}</p>
        </div>
        
        <div class="download-section" [@fadeInUp]>
          <div class="download-buttons">
            <button class="store-button app-store" (click)="openQRModal('appstore')" [@slideInLeft]>
              <div class="button-content">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"></path>
                </svg>
                <div class="button-text">
                  <span class="download-text">{{ t('lang.downloadOn') }}</span>
                  <span class="store-name">App Store</span>
                </div>
              </div>
              <div class="button-glow"></div>
            </button>
            
            <button class="store-button play-store" (click)="openQRModal('playstore')" [@slideInRight]>
              <div class="button-content">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 20.5v-17c0-.59.34-1.11.84-1.35l13.69 8.5-13.69 8.5c-.5-.24-.84-.76-.84-1.35zm13.81-5.38L6.05 21.07l8.49-8.49 2.27 2.54zm0-6.24l-2.27 2.54-8.49-8.49L16.81 8.88zm2.58.82l-2.31 1.43-2.31-2.59L19.39 9.7z"></path>
                </svg>
                <div class="button-text">
                  <span class="download-text">{{ t('lang.getItOn') }}</span>
                  <span class="store-name">Google Play</span>
                </div>
              </div>
              <div class="button-glow"></div>
            </button>
          </div>
        </div>
        
        <div class="alternative-actions" [@fadeInUp]>
          <div class="action-buttons">
            <mzic-button (click)="navigateToHome()" [ariaLabel]="'Go to Homepage'">
              <span class="button-content">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"></path>
                </svg>
                {{ t('lang.goHome') }}
              </span>
            </mzic-button>
          </div>
        </div>
      </div>
      
      <div class="background-elements">
        <div class="gradient-orb orb-1"></div>
        <div class="gradient-orb orb-2"></div>
        <div class="gradient-orb orb-3"></div>
      </div>
    </div>
  </section>

  <!-- QR Download Modal -->
  <mzic-qr-download-modal
    [isVisible]="showQRModal"
    [activeStore]="activeStore"
    [config]="qrModalConfig"
    [translationScope]="'lang.qrModal'"
    (closeModal)="onCloseQRModal()"
    (directLinkClick)="onDirectLinkClick($event)">
  </mzic-qr-download-modal>

</ng-container> 